var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91602 3.75065C5.86999 3.75065 5.83268 3.78796 5.83268 3.83398V6.50065H9.99935V3.83398C9.99935 3.78796 9.96204 3.75065 9.91602 3.75065H5.91602ZM4.66602 3.83398V6.50065H3.33268C2.96449 6.50065 2.66602 6.79913 2.66602 7.16732V13.1673C2.66602 13.5355 2.96449 13.834 3.33268 13.834H12.666C13.0342 13.834 13.3327 13.5355 13.3327 13.1673V7.16732C13.3327 6.79913 13.0342 6.50065 12.666 6.50065H11.166V3.83398C11.166 3.14363 10.6064 2.58398 9.91602 2.58398H5.91602C5.22566 2.58398 4.66602 3.14363 4.66602 3.83398ZM3.66602 7.50065V12.834H12.3327V7.50065H3.66602ZM6.66602 10.4173H9.33268V9.25065H6.66602V10.4173Z",
    fill: "#7C7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityInvisible);
export default __webpack_public_path__ + "static/media/visibility-invisible.093a4ee16f5a18d4b334a7476d75de34.svg";
export { ForwardRef as ReactComponent };